import React from "react";
import "./Contact.css";

const ContactUs = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      service: e.target.service.value,
      message: e.target.message.value,
    };

    try {
      const response = await fetch("http://localhost:5000/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
       if (response.ok) {
        alert("Thank you! Your message has been sent.");
        e.target.reset();
      } else {
        alert("Oops! Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      alert("Error sending message.");
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <h1>Let’s Connect for Smarter Water Solutions</h1>
        <p>We’re here to support industrial, environmental, and pool projects with clarity and trust.</p>
        <a href="#contact-form" className="cont-btn-primary">Get in Touch</a>
      </section>

      {/* Contact Info Grid */}
      <section className="cont-info-grid">
        <div className="cont-info-card">
          <span className="cont-icon">🏢</span>
          <h3>Headquarters</h3>
          <p>Crystal Drops HQ<br/>Bengaluru,India</p>
          <iframe 
          title="HQ map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62191.65790020824!2d77.52185592167966!3d13.037032900000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17a6d4db1fef%3A0x5be295ee74627bde!2sCrystal%20Drops!5e0!3m2!1sen!2sus!4v1765376686699!5m2!1sen!2sus"
          width="100%"
            height="200"
            style={{ border: 0, borderRadius: "8px", marginTop: "1rem" }}
            allowFullScreen=""
            loading="lazy"
             >
             </iframe>
          <a
            href="https://maps.app.goo.gl/yEGwfN9rTH2m9Z8z6"
            target="_blank"
            rel="noopener noreferrer"
            className="cont-btn-secondary"
          >
            Get Directions
          </a>
        </div>

        <div className="cont-info-card">
          <span className="cont-icon">🏬</span>
          <h3>Branch Office</h3>
          <p>Crystal Drops Branch<br/>Hyderabad, India</p>
         <iframe 
         title="Branch Map"
         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.2132760032687!2d78.3433995736922!3d17.49732959963157!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb926442295e3b%3A0x62ef55b1193e42ba!2sBHEL%20Manasa%20Executive%20Apartment!5e0!3m2!1sen!2sin!4v1765377988244!5m2!1sen!2sin" 
         width="100%"
            height="200"
            style={{ border: 0, borderRadius: "8px", marginTop: "1rem" }}
            allowFullScreen=""
            loading="lazy"></iframe>
          <a
            href="https://maps.app.goo.gl/VCfafESeG4Fxck767"
            target="_blank"
            rel="noopener noreferrer"
            className="cont-btn-secondary"
          >
            Get Directions
          </a>
        </div>

        <div className="cont-info-card">
          <span className="cont-icon">📞</span>
          <h3>Phone & WhatsApp</h3>
          <p>+91 94484 40647 <br></br>+91 95133 12257 <br></br>+91 91085 18722</p>
        </div>

        <div className="cont-info-card">
          <span className="cont-icon">✉️</span>
          <h3>Email Support</h3>
          <p>sales@crystaldrops.co.in <br></br>info@crystaldrops.co.in</p>
        </div>

        <div className="cont-info-card">
          <span className="cont-icon">📍</span>
          <h3>Warehouse Address</h3>
          <p>No. 1, 9th Cross, Hurulichikkanahalli, Hesaraghatta main road, Bangalore North Taluk, Bengaluru Urban, Karnataka, 560090</p>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact-form" className="cont-form-section">
        <h2>Send Us a Message</h2>
        <form onSubmit={handleSubmit}>
          <input id="name" name="name" type="text" placeholder="Your Name" required />
          <input id="email" name="email" type="email" placeholder="Your Email" required />
          <input id="phone" name="phone" type="tel" placeholder="Phone Number" />
          <select id="service" name="service" required>
            <option value="">Select Service Type</option>
            <option value="Industrial">Industrial</option>
            <option value="Domestic">Domestic</option>
            <option value="Environmental">Environmental</option>
            <option value="Swimming Pool">Swimming Pool</option>
          </select>
          <textarea id="message" name="message" placeholder="Your Message" required></textarea>
          <button type="submit" className="cont-btn-primary">Send Message</button>
        </form>
      </section>
    </div>
  );
};

export default ContactUs;